import {Depuis} from 'api-types/ffconnect';
import {ContextsComposant} from '../types/ContextsComposant';

export const context_to_depuis: Record<ContextsComposant, Depuis | undefined> =
  {
    cadencier: 'cadencier',
    liste: 'liste',
    fiche_produit: 'fiche',
    panier: 'panier',
    modale_preco: 'precommande',
    commande: 'commande',
    operation_commerciale: 'operation_commerciale',
    indisponible: 'autre',
    catalogue: 'catalogue',
    search_bar: 'search_bar',
    search_results: 'search_results',
    search_sidebar: 'search_results',
    accueil: 'accueil',
    menu_catalogue: 'menu',
    menu_catalogue_mobile: 'menu',
    liste_detail: 'liste',
    ub_essentielles: 'ub_essentielles',
  };

// Converti le ContextsComposant en une source utilisée pour le tracking
export const contextToDepuis: (
  context: ContextsComposant | undefined,
) => Depuis = (context) => {
  if (!context) return 'autre';
  return context_to_depuis[context] ?? 'autre';
};
